import moment from 'moment';
import isEqual from 'lodash/isEqual';
import ContractService from 'aurora-composition/services/contractsService';
import PropertiesService from 'aurora-composition/services/propertyService';
import DocumentService from 'aurora-composition/services/documentService';
import MusatahaContractRegistrationService from 'aurora-composition/services/musatahaContractRegistrationService';
import { getPropertType } from 'aurora-utils/utils';
import AuthService from 'aurora-composition/services/authService';
import LeaseService from 'aurora-composition/services/leaseService';
import * as types from './constants';

// const MORTGAGED_CONTRACTS_SERACH = 256;

// fetch Document
export const fetchDocument = async applicationId => {
  try {
    const responseDocument = await DocumentService.fetchApplicationDocuments({ applicationId });
    return responseDocument?.data?.result || responseDocument?.result || null;
  } catch (e) {
    return null;
  }
};
// fetch property
export const fetchPropertyDetail = async plotId => {
  try {
    const responseProperty = await PropertiesService.fetchPropertyLease(plotId);
    const data = responseProperty?.result;
    const propertyDetail = {};
    const en = {};
    const ar = {};
    if (data) {
      en.type = getPropertType(data?.propertyType);
      ar.type = getPropertType(data?.propertyType);

      en.title = data?.plotNumber + ', ' + data?.communityEn;
      ar.title = data?.plotNumber + ', ' + (data?.communityAr === null ? data?.communityEn : data?.communityAr);

      en.muncipality = data?.muncipalityEn;
      en.unitRegistrationNumber = data?.unitRegistrationNumber;
      en.plotNumber = data?.plotNumber;
      en.district = data?.districtEn;
      en.buildingNumber = data?.buildingNumber;
      en.plotID = data?.propertyID;
      en.municipalityID = data?.municipalityID;
      en.location = data?.location;
      en.community = data?.communityEn;
      en.propertyType = data?.propertyType;
      en.plotAddress = data?.plotAddress;
      en.municipalityNameEn = data?.muncipalityEn;
      en.unitNumber = data?.unitNumber;
      en.unitUsage = data?.unitUsageTypeEn;
      en.propertyRegistrationNumber = data?.propertyRegistrationNumber;
      en.plotAddress = data?.plotAddress;
      en.road = data?.roadEn;
      en.premiseNumber = data?.premiseNumber;
      en.contractDetail = null;

      const contractDetaulEn = {};
      const contractDetail = data?.contractDetail;
      if (contractDetail) {
        contractDetaulEn.contractId = contractDetail?.contractId;
        contractDetaulEn.applicationId = contractDetail?.applicationId;
        contractDetaulEn.contractNo = contractDetail?.contractNo;
        contractDetaulEn.tenantName = contractDetail?.tenantNameEn;
        contractDetaulEn.contractAmount = contractDetail?.contractAmount;
        contractDetaulEn.contractStatus = contractDetail.contractStatusEn;
        contractDetaulEn.contractStartDate = moment(contractDetail?.contractStartDate).format('DD-MM-YYYY');
        contractDetaulEn.contractEndDate = moment(contractDetail?.contractEndDate).format('DD-MM-YYYY');
        en.contractDetail = contractDetaulEn;
      }

      ar.plotAddress = data?.plotAddress;
      ar.propertyRegistrationNumber = data?.propertyRegistrationNumber;
      ar.plotNumber = data?.plotNumber;
      ar.unitRegistrationNumber = data?.unitRegistrationNumber;
      ar.unitNumber = data?.unitNumber;
      ar.muncipality = data?.muncipalityAr;
      ar.buildingNumber = data?.buildingNumber;
      ar.district = data?.districtAr;
      ar.plotID = data?.propertyID;
      ar.municipalityID = data?.municipalityID;
      ar.location = data?.location;
      ar.community = data?.communityAr;
      ar.propertyType = data?.propertyType;
      ar.plotAddress = data?.plotAddress;
      ar.municipalityNameAr = data?.muncipalityAr;
      ar.unitUsage = data?.unitUsageTypeAr;
      ar.road = data?.roadAr;
      ar.premiseNumber = data?.premiseNumber;
      ar.contractDetail = null;
      const contractDetaulAr = {};
      if (contractDetail) {
        contractDetaulAr.contractId = contractDetail?.contractId;
        contractDetaulAr.applicationId = contractDetail?.applicationId;
        contractDetaulAr.contractNo = contractDetail?.contractNo;
        contractDetaulAr.tenantName = contractDetail?.tenantNameEn;
        contractDetaulAr.contractAmount = contractDetail?.contractAmount;
        contractDetaulAr.contractStatus = contractDetail.contractStatusEn;
        contractDetaulAr.contractStartDate = moment(contractDetail?.contractStartDate).format('DD-MM-YYYY');
        contractDetaulAr.contractEndDate = moment(contractDetail?.contractEndDate).format('DD-MM-YYYY');
        en.contractDetail = contractDetaulEn;
      }
    }
    propertyDetail.en = en;
    propertyDetail.ar = ar;
    propertyDetail.propertyObj = data;

    return propertyDetail;
  } catch (e) {
    return null;
  }
};

// fetch lease properties in case multiple units
export const fetchLeaseProperties = async contractId => {
  try {
    const res = await ContractService.fetchLeaseContractProperties({ contractId, size: 100, page: 0 });

    return res?.result?.properties;
  } catch (e) {
    return null;
  }
};

export const fetchContracts = (body, params) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_CONTRACTS });

    const contracts = await ContractService.fetchContracts(body, params);

    dispatch({ type: types.FETCH_CONTRACTS_SUCCESS, payload: { contracts } });
  } catch (error) {
    dispatch({
      type: types.FETCH_CONTRACTS_ERROR,
      payload: { error },
    });
  }
};

export const fetchPMAProperties = (id, params = null) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_PMA_PROPERTIES });
    const { contract } = getState().contractReducer;

    const property = await ContractService.fetchContractPmaBuildings(id, params);

    dispatch({
      type: types.FETCH_CONTRACT_DETAIL_SUCCESS,
      payload: { contract: { ...contract, properties: property?.result } },
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_CONTRACT_DETAIL_ERROR,
      payload: { message: error?.message, statusCode: error?.statusCode, error: error?.message },
    });
  }
};

export const fetchContractDetail = (
  id,
  params = null,
  noDocumentRequired = false,
  { contractType } = {},
) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_CONTRACT_DETAIL });
    let res = null;
    let property = null;
    let selectedProperties = null;
    let contract = null;
    if (params === 'lease') {
      res = await ContractService.fetchContract(id);
      contract = res?.result;
      contract.properties = res?.result?.property;
      // Selected Properties for Multiple Units
      if (contract?.multipleUnit === true) {
        selectedProperties = await fetchLeaseProperties(id);
        contract.selectedProperties = selectedProperties;
      } else {
        // Property for Single Unit
        property = await fetchPropertyDetail(res?.result?.property?.plotId);
        contract.property = property;
      }
    } else if (params === 'pma') {
      res = await ContractService.fetchContractPma(id);
      contract = res?.result;
      // property
      property = await ContractService.fetchContractPmaBuildings(id);
      contract.properties = property?.result;

      contract.property = null;
    } else if (params === 'offPlan') {
      res = await ContractService.fetchContractOffPlan(id);
      contract = res?.result;

      contract.property = null;
    } else if (params === 'musataha') {
      if (contractType === 'Individual') {
        res = await ContractService.fetchContractMusatahaIndividual(id);
        contract = res?.result?.details;
      } else {
        res = await ContractService.fetchContractMusataha(id);
        contract = res?.result?.musatahaContract;
      }
    }

    if (noDocumentRequired !== true) {
      // document
      let documents = [];
      if (contract?.applicationId) {
        documents = await fetchDocument(contract?.applicationId);
      }

      contract.documents = documents;
    }

    dispatch({ type: types.FETCH_CONTRACT_DETAIL_SUCCESS, payload: { contract } });
    return contract;
  } catch (error) {
    dispatch({
      type: types.FETCH_CONTRACT_DETAIL_ERROR,
      payload: { message: error?.message, statusCode: error?.statusCode, error: error?.message },
    });
    return error;
  }
};
// eslint-disable-next-line consistent-return
export const fetchPmaPropertyUnits = (contractId, buildingId) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PMA_CONTRACT_UNITS });

    // fetch application
    const response = await ContractService.fetchContractPmaBuildingUnits(contractId, buildingId);
    const res = response?.result;
    dispatch({
      type: types.FETCH_PMA_CONTRACT_UNITS_SUCCESS,
      payload: {
        units: res,
      },
    });
    return res;
  } catch (e) {
    dispatch({
      type: types.FETCH_PMA_CONTRACT_UNITS_ERROR,
      payload: {
        error: e,
      },
    });
  }
};
// Action v2
const operationStart = () => ({
  type: types.CONTRACT_OPERATION_START,
});

const operationEnd = error => ({
  type: types.CONTRACT_OPERATION_END,
  payload: { error },
});

export const fetchContractsV2 = ({ page, pageSize, filters, defaultFilters }) => async (dispatch, getState) => {
  try {
    const { query: prevQuery, contracts: prevContracts } = getState().contractReducer;
    dispatch(operationStart());
    const priorityFilter = { ...defaultFilters };
    if (filters?.contractStatus) {
      priorityFilter.contractStatus = filters?.contractStatus;
    } else if (defaultFilters?.contractStatus) {
      priorityFilter.contractStatus = defaultFilters?.contractStatus;
    }
    const body = {
      // ...defaultFilters,
      ...(filters?.contractId &&
        filters.type !== 'Offplan' &&
        filters.type !== 'Musataha' &&
        filters?.contractSearchType !== 'Mortgage' && { contractId: filters?.contractId }),
      ...(filters?.contractId && filters?.contractSearchType === 'Mortgage' && { agreementNum: filters?.contractId }),
      ...(filters?.contractId &&
        (filters.type === 'Offplan' || filters.type === 'Musataha' || filters.type === 'Poa') && {
          contractNumber: filters?.contractId,
        }),
      ...(filters?.contractClassificationType && { contractClassificationType: filters?.contractClassificationType }),
      // ...(filters?.contractStatus && { contractStatus: filters?.contractStatus }),
      ...(filters?.municipality &&
        filters?.contractSearchType !== 'Mortgage' && { municipalityId: filters?.municipality }),
      ...(filters?.community && { communityId: filters?.community }),
      ...(filters?.district && { districtId: filters?.district }),
      ...(filters?.fromDate && filters?.contractSearchType !== 'Mortgage' && { fromDate: filters?.fromDate }),
      ...(filters?.toDate && filters?.contractSearchType !== 'Mortgage' && { toDate: filters?.toDate }),
      ...(filters?.buildingRegNumber && { buildingRegNumber: filters?.buildingRegNumber }),
      ...(filters?.unitId && { unitId: filters?.unitId }),
      ...(filters?.unitNumberOrName && { unitNumberOrName: filters?.unitNumberOrName }),
      ...(filters?.unitNumber && { unitNumber: filters?.unitNumber }),
      ...(filters?.premiseId && { premiseId: filters?.premiseId }),
      ...(filters?.tenantPhoneNumber && { tenantPhoneNumber: filters?.tenantPhoneNumber }),
      ...(filters?.tenantName && { tenantName: filters?.tenantName }),
      ...(filters?.tenantEidUnifiedOrTLNumber && { tenantEidUnifiedOrTLNumber: filters?.tenantEidUnifiedOrTLNumber }),
      ...(filters?.contractSearchType &&
        filters?.contractSearchType !== 'Poa' &&
        filters?.contractSearchType !== 'Mortgage' && { contractSearchType: filters?.contractSearchType }),
      ...(filters?.contractClassificationId && { contractClassificationId: filters?.contractClassificationId }),
      ...(filters?.contractSearchType !== 'Mortgage'
        ? { projectId: filters?.projectId }
        : { projectNameEn: filters?.projectNameEn }),
      ...(filters?.projectId && { projectId: filters?.projectId }),
      ...(filters?.pmaClassification && { pmaClassification: filters?.pmaClassification }),
      ...(filters?.plotNumber && { plotNumber: filters?.plotNumber }),
      ...(filters?.floorNumber && { floorNumber: filters?.floorNumber }),
      ...(filters?.dateOfSale && { dateOfSale: filters?.dateOfSale }),
      ...(filters?.buildingNumber && { buildingNumber: filters?.buildingNumber }),
      ...(filters?.buildingNameEn && { buildingNameEn: filters?.buildingNameEn }),
      ...(filters?.allocationType && { allocationType: filters?.allocationType }),
      ...(filters?.paymentStatus && { paymentStatus: filters?.paymentStatus }),
      ...(filters?.isSublease && { isSubLease: filters?.isSublease === 'true' }),
      ...(filters?.isPropertyActive && { isPropertyActive: filters?.isPropertyActive }),
      pageSize,
      pageNumber: page - 1,
      ...(filters?.contractSearchType === 'Mortgage' && {
        ...(filters?.contractId &&
          filters?.contractSearchType !== 'Mortgage' && { mortgageContractNumber: filters?.contractId }),
        ...(filters?.fromDate && { agreementStartDate: filters?.fromDate }),
        ...(filters?.toDate && { agreementEndDate: filters?.toDate }),
      }),

      ...(filters?.contractSearchType === 'Poa' && {
        searchType: 'CONTRACT',
      }),

      ...priorityFilter,
    };
    const params = { page: page - 1, size: pageSize };
    const query = { ...params, ...body };

    if (isEqual(prevQuery, JSON.stringify(query)) && prevContracts) {
      dispatch({
        type: types.FETCH_CONTRACTS_V2,
        payload: { query: prevQuery, contracts: prevContracts },
      });
      return;
    }

    const ENDPOINTS_MAP = {
      Lease: ContractService.fetchContracts,
      Pma: ContractService.fetchContracts,
      Offplan: ContractService.fetchContractsOffPlan,
      Musataha: ContractService.fetchContractsMusataha,
      Mortgage: ContractService.fetchContractsMortgage,
      Poa: ContractService.fetchContractsPoa,
    };

    const contracts = await ENDPOINTS_MAP[filters.type ?? filters?.contractSearchType](body, params);

    if (!contracts?.success || !contracts?.result) throw new Error('unable_to_fetch_contracts');
    dispatch({
      type: types.FETCH_CONTRACTS_V2,
      payload: { contracts: contracts?.result, query: JSON.stringify(query) },
    });
  } catch (error) {
    dispatch(operationEnd(error));
  }
};

export const fetchContractType = type => async dispatch => {
  try {
    let contractTypeValue = '';
    if (type === 'Pma') contractTypeValue = 'PropertyManagementAgreement';
    const contractTypes = await ContractService.fetchContractTypes({ contractType: contractTypeValue });
    dispatch({
      type: types.FETCH_CONTRACT_TYPES,
      payload: { contractTypes: contractTypes?.result },
    });
  } catch (error) {
    dispatch(operationEnd(error));
  }
};
export const fetchOffPlanProjects = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFF_PLAN_PROJECTS });
    const response = await AuthService.fetchOffPlanProjects();
    dispatch({
      type: types.FETCH_OFF_PLAN_PROJECTS_SUCCESS,
      payload: {
        projects: response?.projects,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_OFF_PLAN_PROJECTS_FAILURE, payload: error });
  }
};

export const fetchMuastahaLandUse = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LAND_USE_MUSTAHA });
    const response = await ContractService.fetchMustahaLandUse();
    dispatch({
      type: types.FETCH_LAND_USE_MUSTAHA_SUCCESS,
      payload: {
        landUse: response?.result?.items,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_LAND_USE_MUSTAHA_FAILURE, payload: error });
  }
};

export const downloadContract = (id, title = 'Off-Plan_Contract', param = null, contract) => async dispatch => {
  try {
    console.log(param);
    dispatch({ type: types.DOWNLOAD_OFF_PLAN_CONTRACT });
    let documentPdf = null;
    if (contract) {
      documentPdf = await DocumentService.downloadDocumentOffPlanContract(id);
    } else {
      documentPdf = await DocumentService.downloadDocumentOffPlanApplication(id);
    }
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    // window.open(fileURL);
    const link = document.createElement('a');

    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_OFF_PLAN_CONTRACT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_OFF_PLAN_CONTRACT_FAILURE, payload: error });
  }
};

export const downloadLeaseContract = (id, name = 'Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_LEASE_PMA_CONTRACT });
    const documentPdf = await ContractService.downloadLeaseContract(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    // window.open(fileURL);
    const link = document.createElement('a');

    const title = name?.defaultmessages || name;
    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_LEASE_PMA_CONTRACT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_LEASE_PMA_CONTRACT_FAILURE, payload: error });
  }
};
export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT });

    const params = { ...payload, header: true };
    const documentPdf = await DocumentService.downloadDocumentV2(params);

    const fileURL = 'data:' + documentPdf?.result?.fileExtension + ';base64,' + documentPdf?.result?.bytes;

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', documentPdf?.result?.fileName);

    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_CONTRACT_DETAIL_DOCUMENT_FAILURE, payload: error });
  }
};

export const fetchPropertyDetails = propertyId => async dispatch => {
  try {
    dispatch({ type: types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_LOADING });
    const data = await PropertiesService.fetchProperty(propertyId);
    dispatch({ type: types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS, payload: data?.result });
    return data;
  } catch (error) {
    dispatch({ type: types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_FAILURE, payload: error });
    return error;
  }
};
export const downloadIndividualMusatahaContract = (id, title = '_Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT });
    let documentPdf = null;
    documentPdf = await MusatahaContractRegistrationService.downloadIndividualMusatahaContract(id);

    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    const link = document.createElement('a');

    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_MUSATAHA_INDIVIDUAL_CONTRACT_FAILURE, payload: error });
  }
};

export const updateSubleasePermissions = payload => async dispatch => {
  try {
    dispatch({ type: types.UPDATE_PERMISSION_LOADING });
    await LeaseService.updateSubleasePermissions(payload);
    dispatch(fetchContractDetail(payload.contractId, 'lease'));
  } catch (error) {
    dispatch({
      type: types.UPDATE_PERMISSION_ERROR,
      payload: error,
    });
  }
};
